import { render, staticRenderFns } from "./AddToCart.vue?vue&type=template&id=4332830b&scoped=true&"
import script from "./AddToCart.vue?vue&type=script&lang=js&"
export * from "./AddToCart.vue?vue&type=script&lang=js&"
import style0 from "./AddToCart.vue?vue&type=style&index=0&id=4332830b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4332830b",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DialogAuthorizationMyAcuvue: require('/var/www/linza-front/linza-front-20251128110242/components/common/DialogAuthorizationMyAcuvue.vue').default})
